import { render, staticRenderFns } from "./119.vue?vue&type=template&id=bbc97cb6&scoped=true&"
var script = {}
import style0 from "./119.vue?vue&type=style&index=0&id=bbc97cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc97cb6",
  null
  
)

export default component.exports